export const menu = [
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Pagine'
    },
    {
        "type": 'item',
        "href": '/',
        "icon": 'home',
        "entity": '',
        "label": 'Dashboard'
    },
    {
        "type": 'item',
        "href": '/entity/job_post',
        "icon": 'list',
        "entity": 'job_post',
        "label": 'Posizioni'
    },
    /* {
        "type": 'item',
        "href": '/entity/job_request',
        "icon": 'folder-open',
        "entity": 'job_request',
        "label": 'Candidature'
    }, */
    /* {
        "type": 'item',
        "href": '/entity/job_post_favourites',
        "icon": 'heart',
        "entity": 'job_post_favourites',
        "label": 'Posizioni salvate'
    }, */
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Parametri'
    },
    {
        "type": 'item',
        "href": '/entity/country',
        "icon": 'globe',
        "entity": 'country',
        "label": 'Nazioni'
    },
    {
        "type": 'item',
        "href": '/entity/location',
        "icon": 'location-dot',
        "entity": 'location',
        "label": 'Sedi'
    },
    {
        "type": 'item',
        "href": '/entity/sector',
        "icon": 'wrench',
        "entity": 'sector',
        "label": 'Settori'
    },
    {
        "type": 'item',
        "href": '/entity/role',
        "icon": 'compass-drafting',
        "entity": 'role',
        "label": 'Ruoli'
    },
    {
        "type": 'item',
        "href": '/entity/agency',
        "icon": 'house-laptop',
        "entity": 'agency',
        "label": 'Agenzie'
    },
    {
        "type": 'item',
        "href": '/entity/tag',
        "icon": 'hashtag',
        "entity": 'tag',
        "label": 'Tag'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Utente'
    },
    {
        "type": 'item',
        "href": '/settings',
        "icon": 'user-gear',
        "entity": '',
        "label": 'Profilo'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cogs',
        "entity": '',
        "label": 'Impostazioni',
        "items": [
            {
                "type": 'item',
                "href": '/entity/user',
                "entity": 'user',
                "label": 'Utenti'
            },
            {
                "type": 'item',
                "href": '/entity/user_group',
                "entity": 'user_group',
                "label": 'Gruppi'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_saved_filters',
                "entity": 'user_entity_saved_filters',
                "label": 'Filtri salvati'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_preferences',
                "entity": 'user_entity_preferences',
                "label": 'Preferenze entità'
            },
        ]
    },
    {
        "type": 'item',
        "href": '/logout',
        "icon": 'arrow-right-from-bracket',
        "entity": '',
        "label": 'Logout'
    }
]